import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useGetBankAccountById = id => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled: !!id,
    queryKey: [QUERY_KEYS.cash.bank_account_detail, id],
    queryFn: () =>
      cashService.bankAccountDetail(id).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
